/*
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: Smart Chow
 * @LastEditTime: 2022-01-05 22:32:46
 * @FilePath: /nqc-ui/src/frameworks/auths/tokenService.js
 */
import moment from 'moment'

let inner_tokeninfo = null

export default {
  // 获取token信息
  getTokenInfo: function () {
    return inner_tokeninfo
  },
  // 设置token信息
  setTokenInfo: function (tokeninfo) {
    if (tokeninfo) {
      inner_tokeninfo = tokeninfo
    }
  },

  // 获得token字符串值
  getTokenValue: function () {
    if (inner_tokeninfo) {
      return inner_tokeninfo.tokenValue
    }
    return null
  },
  // 检查token 是否过期.
  tokenIsExpired: function () {
    if (inner_tokeninfo) {
      return moment().diff(moment(inner_tokeninfo.expirationDate)) > 0
    }
    return false
  },
  // token 是否存在
  tokenExist: function () {
    return true && inner_tokeninfo
  },
  // 获得refresh token字符串值
  getRefreshTokenValue: function () {
    if (inner_tokeninfo) {
      return inner_tokeninfo.refreshToken.tokenValue
    }
    return null
  }
}
